import React from 'react'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import './Pagination.css'

// Gera array de páginas visíveis com reticências
// Ex: [1, '...', 4, 5, 6, '...', 10]
function getPageNumbers(page, totalPages) {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, i) => i + 1)
  }
  const pages = []
  pages.push(1)
  if (page > 3) pages.push('...')
  for (let i = Math.max(2, page - 1); i <= Math.min(totalPages - 1, page + 1); i++) {
    pages.push(i)
  }
  if (page < totalPages - 2) pages.push('...')
  pages.push(totalPages)
  return pages
}

export default function Pagination({ 
  page, 
  totalPages, 
  total,
  hasNext, 
  hasPrev, 
  onPageChange 
}) {
  if (totalPages <= 1) return null

  const pageNumbers = getPageNumbers(page, totalPages)

  return (
    <div className="pagination">
      <button
        className="pagination-button"
        onClick={() => onPageChange(page - 1)}
        disabled={!hasPrev}
        aria-label="Página anterior"
      >
        <ChevronLeft size={18} />
      </button>

      <div className="pagination-pages">
        {pageNumbers.map((p, i) =>
          p === '...' ? (
            <span key={`ellipsis-${i}`} className="pagination-ellipsis">…</span>
          ) : (
            <button
              key={p}
              className={`pagination-page-btn${p === page ? ' active' : ''}`}
              onClick={() => onPageChange(p)}
              aria-label={`Página ${p}`}
              aria-current={p === page ? 'page' : undefined}
            >
              {p}
            </button>
          )
        )}
      </div>

      <button
        className="pagination-button"
        onClick={() => onPageChange(page + 1)}
        disabled={!hasNext}
        aria-label="Próxima página"
      >
        <ChevronRight size={18} />
      </button>
    </div>
  )
}
